module.exports = __webpack_public_path__ + "img/occupy2.628bb763.png";